import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskNotificationsEmailRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-notification-email',
	path: '/jira/servicedesk/projects/:projectKey/settings/notification-email',
	exact: true,
};
